import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { map, timeout, retry, catchError } from 'rxjs/operators';
import { UserSettingsService } from './user-settings.service';
import { UserDataService } from './user-data.service';

export const roleGuard: CanActivateFn = () => {
    const userSettingsService = inject(UserSettingsService);
    const userDataService = inject(UserDataService);
    const router = inject(Router);

    const cached = userSettingsService.getUserSettings();
    if (cached) {
        return userSettingsService.isScaleOperator()
            ? router.createUrlTree(['/scale-view'])
            : true;
    }

    return userDataService.getUserSettings().pipe(
        timeout(10000),
        retry(1),
        map(settings => {
            userSettingsService.setUserSettings(settings);
            return userSettingsService.isScaleOperator()
                ? router.createUrlTree(['/scale-view'])
                : true;
        }),
        catchError(() => of(true))
    );
};
